<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" width="450" id="roeconfirmationDialog" styleClass="confirmation-dialog" appendTo="body"></p-confirmDialog>

<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="DefaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    [FilterFieldDefaultValues]="filterFieldDefaultValues"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- End of Quick search common component -->

<!--Filter Code  -->
<div class="col-lg-12 nopadding">
  <app-filter-panel 
    pageName="CAT-ROE-Viewer"
    [GridColumns]="GridColumns" 
    [DefaultFilterArray]="DefaultFilterArray"
    [ActiveApplicationFilter]="optedApplicationFilter"
    (FilterEvent)="FilterApplyFilterEvent($event)" 
    (FilterEventClearSymbol)="FilterEventClearSymbol($event)" 
    (FilterEventClearEventType)="FilterEventClearEventType($event)"
    (FilterEventClearRepresentativeOrder)="FilterEventClearRepresentativeOrder($event)"
    (clearApplicationFilter)="FilterClearApplicationFilter($event)"
    (RetrieveApplicationFilters)="getApplicationFilters($event)">
  </app-filter-panel>
</div>

<!-- Filter Quick Fields Panel Code -->
<div class="col-lg-12 nopadding">
  <app-symbol-panel 
    [SymbolArray]="SymbolsArray" 
    [quickFilterEventTypeArray]="quickFilterEventTypeArray" 
    [applicationFiltersArray]="applicationFilters"
    [rowCount]="totalRecords" 
    [rowCountSymbol]="totalRecords"
    [rowCountSymbolEventType]="totalRecords"
    [selectedApplicationFilter]="optedApplicationFilter"
    (ActiveSymbolEvent)="setActiveSymbolEvent($event)"
    (ActiveQuickFilterEventType)="setActiveQuickFilterEventType($event)"
    (ActiveApplicationFilter)="setActiveApplicationFilter($event)"
    (RemoveApplicationFilterQuery)="RemoveOptedApplicationFilter($event)">
  </app-symbol-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    @if(isLoadingResults){
    <mat-spinner></mat-spinner>}
  </div>}
  <div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
  <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu>  
  <p-table 
    alwaysShowPaginator="true" 
    paginatorPosition="both" 
    showCurrentPageReport="true"
    [value]="dataset1" 
    [class.catROEtable-frozen]="commonColService.isFrozenColumns"
    [columns]="commonColService.selectedColumns" 
    [resizableColumns]="true" 
    columnResizeMode="expand"
    [totalRecords]="totalRecords" 
    [(selection)]="this.dataService.roeSelectedRecords"
    [paginator]="true"
    appendTo="body"
    (onPage)="changePage($event)"
    (onSort)="sort($event)" 
    sortMode="multiple"
    [rows]="constantService.DEFAULT_ROWSIZE" 
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS"
    [rowsPerPageOptions]="rowsPerPageOptions"  
    [lazy]="true" 
    [scrollable]="true" 
    scrollHeight="60vh"
    styleClass="catroeviewer"
    [reorderableColumns]="true"
    (onColReorder)="commonColService.onColumnsReordered($event, dt)"
    #dt>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{tbldatamsg}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
          <th id="catROEViwerTableHeaderCheckbox" style="width: 3em" pFrozenColumn
                [frozen]= "commonColService.hasFrozenColumns()" >
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
             @for (col of columns; track col.field + '-' + $index){
             <th [attr.id]="'col-' + col.field" pResizableColumn [pSortableColumn]="col.field"
                pFrozenColumn 
                pReorderableColumn
                [frozen]="col.field === 'rsmsStatus' ? commonColService.hasFrozenColumns() : col.frozen" 
                alignFrozen="left"
                [style.left]="(col.field === 'rsmsStatus' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                [style.background-color]="col.frozen && !commonColService.selectedFields.includes(col.field) ? 'sortClass' : null"
                [class.selected-header]="commonColService.selectedFields.includes(col.field)"
                (mousedown)="commonColService.onHeaderMouseDown($event, col.field)"
                (mouseenter)="commonColService.onHeaderMouseEnter(col.field)"
                (contextmenu)="commonColService.onHeaderContextMenu($event, col.field,contextMenuItems, dt)" 
                [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
              <div class="header-cell-content" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <span [class.excel-cursor-span]="(col.header | lowercase) !== 'action'"  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{col.header}}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>}
          </span>
                      @if(col.frozen) {
                          <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 4px;"></i>
                      }
                      </div>
        </th>}
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex"
        [ngClass]="(row['rsmsStatus'] | lowercase)== 'u' ? 'ui-widget-updated-row' : (row['rsmsStatus'] | lowercase) == 'd' ? 'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row'">
        <td style="width: 3em;padding-left: 6px !important;" pFrozenColumn
                [frozen]= "commonColService.hasFrozenColumns()">
            <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row" (click)="displayDropdownTypeBySelectedType(row);"></p-tableCheckbox>
          </td>
           @for (col of columns; track col.field + '-' + $index){
        <td class="ui-resizable-column"
                pFrozenColumn
                [frozen]="col.field === 'rsmsStatus' ? commonColService.hasFrozenColumns() : col.frozen"
                alignFrozen="left"
                [style.left]="(col.field === 'rsmsStatus' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                [style.background-color]="this.dataService.roeSelectedRecords?.includes(row)? '#88c0eb': (col.frozen ? '#e2f0d9' : null)"         
                 [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
          <!-- set String -->
           @if((col.datatype | lowercase) !='int' && (col.datatype | lowercase) !='float'){
          <span>
            @if((col.header | lowercase) == 'type' && (multiLegEventArray && (multiLegEventArray.includes(row[col.field])))){
            <span>
              <a [matTooltip]="'Num of Legs: ' + (row['numberOfLegs'] > 0 ? row['numberOfLegs'] : 0)" [matTooltipShowDelay]="1000" [matTooltipPosition]="'above'" (click)="onClickMultiLegEvent(rowIndex,row)" class="multilegType">{{row[col.field]}}</a>
            </span>}
            @if((col.header | lowercase) =='order id'){
            <span>
              <a [matTooltip]="(quickFilterEventType === 'Representative Orders')? 'View Representative Order' :'View Order Details'" [matTooltipShowDelay]="1000" appendTo="body" (click)="onRowSelect('OrderID',rowIndex,row)" style="color: blue !important;cursor: pointer">{{row[col.field]}}</a>
            </span>}
            @if((col.header | lowercase) !='order id' && (col.header | lowercase) !== 'symbol' && (multiLegEventArray && !multiLegEventArray.includes(row[col.field]))){
            <span>
                {{row[col.field]}}
            </span>}
            @if((col.header | lowercase) == 'symbol'){
            <div class="pull-right" [ngClass]="'displayWhitespaces'">
              {{row[col.field]}}
            </div>}
          </span>}
               <!-- set int  -->
                @if((col.datatype | lowercase) =='int' || (col.datatype | lowercase) =='float'){
               <span style="float:right;">
                @if(row[col.field]){
               <span>{{row[col.field] * 1 }}</span>}
             </span>}
             @if(col.header === 'Action'){
          <span>
             @if(commonColService.hasFrozenColumns()){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above"
              appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View',rowIndex,row);" [disabled] = "dataService.roeSelectedRecords.length>=2"></p-button>}
            @else{
            @if(dataService.roeSelectedRecords.length<2){
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000" matTooltipPosition="above"
              appendTo="body" icon="fa fa-xxx fa-eye" (click)="onRowSelect('View',rowIndex,row);"></p-button>}}
            <p-button class="pi pi-xxx editIcon" or class="fa fa-xxx editIcon" matTooltip="Edit" [matTooltipShowDelay]="1000" matTooltipPosition="above"
              appendTo="body" icon="fa fa-fw fa-edit" (click)="onRowSelect('edit',rowIndex,row);"></p-button> 
            <p-button class="pi pi-xxx treeViewTcon" or class="fa fa-xxx treeViewTcon" matTooltip="Parent/Child Event Tree" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-tree"
              [id]="'tree'+ rowIndex" (click)="onRowSelect('EventTree',rowIndex,row);"></p-button>
            <p-button class="pi pi-xxx cloneIcon" or class="fa fa-xxx cloneIcon" matTooltip="Submitted ROE Correction" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-clone"
              [id]="'cloneFinraException'+ rowIndex"  (click)="cloneFinraException(row)"></p-button>
            <p-button class="pi pi-xxx listIcon" or class="fa fa-xxx listIcon" matTooltip="Audit-Trail" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-list"
              [id]="'audit'+ rowIndex"  (click)="onRowSelect('AuditTrail',rowIndex,row)"></p-button>
            
          </span>}
        </td>}
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <p-select name="newROEEntry" id="id_newROEEntry" #id_newROEEntry
      [options]="eventList"
      [(ngModel)]="selectedEventType"
      placeholder="New ROE Entry"
      (onChange)="onEventTypeChange($event);" [showClear]="true"
      class="EventTypeDropdown">
    </p-select>
    
      <app-export-to-csv [gridColumns]="exportGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
      <button 
       [matTooltip]="this.UserService.enableFileExport()?'Export Json of the selected/filtered roe records':'Export service is disabled'"
        [matTooltipShowDelay]="1000" class="exportBtn"
        (click)="exportToJSON()" type="button">Export Json <i class="fa fa-download" aria-hidden="true"></i> 
        @if(isExportToJSON){
        <img style="text-align:right" alt="exportTOJSON"
          src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        }
        </button>
      Total Records: {{dataset1.length == 0? 0 : displayTildCount ? '~'+totalRecords : totalRecords}}
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <!-- Page No : {{pageNumber }} -->
      Showing {{dataset1.length == 0? 0 : startLimit + 1}} to {{dataset1.length
          < rowcount ? dataset1.length < startLimit ? endLimit : dataset1.length : endLimit}} entries
           
         </ng-template>
  </p-table>
  </div>
  <br>
  <br>
</div>

<!-- below code to make common edit screen -->
 @if(edit){
<app-single-edit-form 
    [screenType]="'rowViewer'" 
    (closeDialog)="closeDialog($event)" 
    [rowData]="rowDataforDialog" 
    [index]="rowIndexForDialog" 
    [isMultiEdit] = "isMultiEdit"
    [correctCodeLength] ="correctCodeLength"
    [firmROEIDList]="firmROEIDList"
    [value]="actionType">
</app-single-edit-form>}

<p-confirmDialog  
    acceptLabel="Ok" 
    key="informationDialoge" 
    [rejectVisible]="false" 
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999"
    styleClass="confirmation-dialog">
</p-confirmDialog>

<p-confirmDialog
    key="confirmationDialoge"
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999"
    styleClass="confirmation-dialog">
</p-confirmDialog>

@if(this.eventTreeService.isDialogOpen){
<app-event-tree-dialog 
id="cat-roe-parent-child-event-tree" 
[SelectedRow]="selectedRow"
[isTreeOpen]="this.eventTreeService.isDialogOpen"
[pageName]="ApplicationName">
</app-event-tree-dialog>}

@if(isAuditTrail){
<app-audit-trail-dialog 
id="cat-roe-audit-trail" 
(closeEventDialog)="isAuditTrail = false"
[SelectedRow]="selectedRow"
[isAuditTrailOpen]="isAuditTrail"
[pageName]="ApplicationName">
</app-audit-trail-dialog>}

@if(isRepresentativeOrderDisplay){
<app-representative-order
id="cat-roe-representative-order-display" 
(closeEventRepresentativeDialog)="isRepresentativeOrderDisplay = false"
[SelectedRow]="this.dataService.roeSelectedRecords"
[isRepresentativeOrderDisplay]="isRepresentativeOrderDisplay"
>
</app-representative-order>}

<!-- View MultiLeg Events -->
 @if(viewMultiLegEvent){
<app-multileg-event
  id="multileg_event"
  [index]="rowIndexForDialog"
  [rowData]="rowDataforDialog"
  [showMultiLegEvent]="viewMultiLegEvent"
  (closeMultiLegEvent)="closeMultiLegEvent($event)">
</app-multileg-event>}

<!-- Create New ROE Record -->
 @if(displayNewROEDialog){
<app-new-roe-entry #newROEentry
[selectedEventType]="selectedEventType"
[selectedID]="selectedID"
[pageName]="'CAT-ROE-Viewer'"
[reportDate]="selectedReportDate"
[existingEventType]="existingEventType"
[selectedGroupName]="selectedGroupName"
[rowData]="dataService.roeSelectedRecords"
[CATReporterIMID]="CATReporterIMID"
(closeDropdown)="closeDropdown($event)" 
>
</app-new-roe-entry>
}
<!-- End of Create New ROE Record -->